module.exports = __webpack_public_path__ + "static/media/gsuite-top-receivers.3d405ac5.png";